import { FC, useRef, ChangeEvent } from "react";
import styles from "./FileUploaderChat.module.scss";
import attachmentIcon from "../../../images/icons/attachment.svg";
import { useNotification } from "../../Notification/useNotification";

interface FileUploaderProps {
  onFileSelect: (file: File | null) => void;
  selectedFile: File | null;
  disabled?: boolean;
  acceptedFileTypes?: string;
  maxFileSize?: number; // в байтах
}

export const FileUploaderChat: FC<FileUploaderProps> = ({
  onFileSelect,
  selectedFile,
  disabled = false,
  acceptedFileTypes = "*",
  maxFileSize = 5242880, // 5MB по умолчанию
}) => {
  const fileInputRef = useRef<HTMLInputElement>(null);
  const { showError } = useNotification();
  const handleButtonClick = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0] || null;

    if (file) {
      // Проверка размера файла
      if (maxFileSize && file.size > maxFileSize) {
        showError(
          `File is too large. Maximum size: ${maxFileSize / 1024 / 1024}MB`,
        );
        return;
      }

      const allowedImageTypes = /\.(jpeg|jpg|png|gif)$/i;
      if (!allowedImageTypes.test(file.name)) {
        showError(
          "Invalid file type. Only images (jpeg, jpg, png, gif) are allowed.",
        );
        return;
      }
    }

    onFileSelect(file);
  };

  const removeFile = (e: React.MouseEvent) => {
    e.stopPropagation(); // Предотвращаем всплытие события
    onFileSelect(null);
    // Сбрасываем значение input, чтобы можно было выбрать тот же файл снова
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  return (
    <div className={styles.fileUploader}>
      <input
        type="file"
        ref={fileInputRef}
        onChange={handleFileChange}
        className={styles.fileInput}
        disabled={disabled}
        accept={acceptedFileTypes}
      />

      <button
        type="button"
        onClick={handleButtonClick}
        className={styles.attachmentButton}
        title={selectedFile ? selectedFile.name : "Attach file"}
        disabled={disabled}
      >
        <img
          src={attachmentIcon}
          alt="Attach file"
          className={styles.iconMessage}
        />
      </button>

      {selectedFile && (
        <div className={styles.selectedFile}>
          <span className={styles.fileName}>{selectedFile.name}</span>
          <button
            type="button"
            className={styles.removeButton}
            onClick={removeFile}
            title="Remove file"
          >
            &times;
          </button>
        </div>
      )}
    </div>
  );
};
